import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateLocationAddressMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountLocationAddressInput;
}>;

export type UpdateLocationAddressMutationResult = { __typename?: 'Mutation' } & {
  updateAccountLocationAddress?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountLocationAddressPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateLocationAddressDocument = gql`
  mutation updateLocationAddress($input: UpdateAccountLocationAddressInput!) {
    updateAccountLocationAddress(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
